.g{display:flex;}